export default {
  competitor_page_title: '竞品对比',
  competitor_page_xh_title: '竞品对比-去小号',
  competitor_tab_key_metrics: '关键指标',
  competitor_tab_insight: '洞察分析',
  competitor_time_switch_text: '拉齐上线时间/最早数据时间',
  competitor_time_switch_desc: '打开开关后，原先的日期筛选将被重置。请按照上线时间或者最早有数据的时间重新筛选，最早数据时间以新进用户指标为准。',
  competitor_launch: '上线后',
  competitor_earliest_data: '最早日期',
  competitor_launch_Day: '日',
  competitor_launch_Month: '月',
  competitor_competitor: '竞品',
  competitor_competitor_last_one_message: '该选项为最后一个，取消勾选后竞品游戏将没有数据。',
  competitor_source: '来源',
  competitor_key_metrics_trend_title: '关键指标趋势',
  competitor_key_metrics_dau_trend_title: '日活跃',
  competitor_key_metrics_agv_dau_trend_title: '平均日活跃',
  competitor_key_metrics_agv_mau_trend_title: '平均月活跃',
  competitor_key_metrics_wau_trend_title: '周活跃',
  competitor_key_metrics_mau_trend_title: '月活跃',
  competitor_key_metrics_revenue_trend_title: '收入趋势',
  competitor_key_metrics_revenue_trend_tab1: '付费金额',
  competitor_key_metrics_revenue_trend_tab2: '调整后付费金额',
  competitor_key_metrics_adjusted_revenue_desc: `调整后付费金额= Data.ai收入/0.7<br/>Data.ai的收入不包括渠道成本，因此做出了调整。`,
  competitor_key_metrics_new_trend_title: '新进用户',
  competitor_key_metrics_retention_trend_title: '留存',
  competitor_key_metrics_retention_no_data: `按日/周进行统计时，无留存数据。<br/>请切换时间筛选至月粒度查看留存趋势。`,
  competitor_key_metrics_performance_title: '关键指标表现',
  competitor_key_metrics_performance_date: '日期',
  competitor_key_metrics_performance_launch_date: '上线时间',
  competitor_key_metrics_performance_game: '游戏',
  competitor_key_metrics_performance_revenue: '付费金额({unit})',
  competitor_key_metrics_performance_adjusted_revenue: '调整后付费金额({unit})',
  competitor_key_metrics_performance_adjusted:'调整后付费金额({unit})',
  competitor_key_metrics_performance_dau: '日活跃',
  competitor_key_metrics_performance_avg_dau: '平均日活跃',
  competitor_key_metrics_performance_wau: '周活跃',
  competitor_key_metrics_performance_mau: '月活跃',
  competitor_key_metrics_performance_new: '新进用户',
  competitor_key_metrics_performance_d2: '第2天平均留存',
  competitor_key_metrics_performance_d3: '第3天平均留存',
  competitor_key_metrics_performance_d7: '第7天平均留存',
  competitor_key_metrics_performance_d15: '第15天平均留存',
  competitor_key_metrics_performance_d31: '第31天平均留存',
  competitor_key_metrics_performance_tru: '总注册用户数',
  competitor_key_metrics_performance_total_revenue: '总付费金额({unit})',

  competitor_insight_competitive_comparison_title: '竞争力对比',
  competitor_insight_competitive_comparison_module1_title: '收入({unit})与活跃',
  competitor_insight_competitive_comparison_module1_y_lable: '收入',
  competitor_insight_competitive_comparison_module1_x_lable:'活跃',
  competitor_insight_competitive_comparison_module1_x_previous:'上期',
  competitor_insight_competitive_comparison_module1_sum: '总',
  competitor_insight_competitive_comparison_module1_avg: '平均',

  competitor_insight_competitive_comparison_module2_title: '新进与留存',
  competitor_insight_competitive_comparison_module2_y_lable: '留存',
  competitor_insight_competitive_comparison_module2_x_lable:'新进',
  competitor_insight_competitive_comparison_module2_no_data: `按日/周进行统计时，无留存数据。<br/>请切换时间筛选至月粒度，查看新进与留存的关系图`,
}